// Centralized feature-flag helpers. Read from build-time env (CRA injects
// REACT_APP_* into process.env at compile time). Defaults are conservative:
// unset == enabled (keeps dev safe), explicit 'false' == disabled.
//
// Pre-launch (Feb 2026): the Parent module is disabled via
// REACT_APP_ENABLE_PARENT_MODULE=false. Flip to "true" to restore.

// Jun 2026 — the Parent module is PERMANENTLY enabled (public launch):
// the env kill-switch was retired so no production env value can disable
// family/parent registration again.
export const isParentModuleEnabled = () => true;


// ════════════════════════════════════════════════════════════════════════
// Feb 2026 — MIGRATION_MODE
//
// While migrating students from the legacy system + WhatsApp into the
// platform, hide every UI surface that:
//   • Offers a direct subscription / 3-day free trial during signup
//   • Surfaces payment-related lifecycle states (Awaiting_Payment,
//     Subscription_Expired, Trial_Expired, ...) to students, parents
//     OR to operational admin queues
//   • Shows subscription-specific block text to the student
//
// IMPORTANT — this is UI hiding only. We DO NOT delete any code,
// workflow, API, database row, payment plan, financial logic or
// admin financial pages. The financial pipeline keeps running
// exactly as today; it is simply NOT exposed in the migration-phase
// UI. Flip the flag below to `false` (then redeploy) to restore the
// full UI in one line.
//
// Pages that remain fully visible (per product requirement):
//   • Subscriptions.js / FinanceManagement.js / FinanceHub.jsx
//   • Trials.js, Reports.js, Settings.jsx
// …and every backend endpoint and every payment-creation flow.
// ════════════════════════════════════════════════════════════════════════
export const MIGRATION_MODE = true;

// Payment-related access-block reasons emitted by the backend. While
// MIGRATION_MODE is on we hide the specific text (avoids surfacing
// "subscription expired" / "awaiting payment") but we still tell the
// student access is blocked + show the "Contact Administration" CTA.
export const PAYMENT_BLOCKED_REASONS = new Set([
  'awaiting_payment',
  'subscription_expired',
  'trial_expired',
  'subscription_frozen',
  'no_active_subscription',
  'grace_period',
]);
